import { z } from 'zod/v4';

export type AutomationWizardStep = 0 | 1 | 2 | 3 | 4;

export type AutomationWizardControllerState = {
  step: {
    current: AutomationWizardStep;
    highestVisited: AutomationWizardStep;
  };
};

export const AUTOMATION_ACTION_TYPES = [
  'CopyValueToField',
  'CopyFieldToField',
  'AssignAccountManager',
  'AssignRecoveryPlan',
  'Pause',
  'Unpause',
] as const;
export type AutomationActionType = (typeof AUTOMATION_ACTION_TYPES)[number];
export const AutomationActionTypeSchema = z.enum([...AUTOMATION_ACTION_TYPES]);

export const AUTOMATION_MODELS = ['debtor', 'invoice'] as const;
export type AutomationModel = (typeof AUTOMATION_MODELS)[number];
export const AutomationModelSchema = z.enum([...AUTOMATION_MODELS]);

export const AUTOMATION_TRIGGERS = ['on_create', 'on_update'] as const;
export type AutomationTrigger = (typeof AUTOMATION_TRIGGERS)[number];
export const AutomationTriggerSchema = z.enum([...AUTOMATION_TRIGGERS]);
